import {loader as loaderVue} from 'x.vue.loader';
import {Validator} from 'x.util'
import {iziToast} from 'x.izi'

import {CalculatorWoods_tboard} from './cw_tboard.js';
import {CalculatorWoods_plank} from './cw_plank.js';
import {CalculatorWoods_fboard} from './cw_fboard.js';
import {CalculatorWoods_eurvagon} from './cw_eurvagon.js';

import './cw.css';


export const CalculatorWoods = {
    components: {
            CalculatorWoods_tboard: CalculatorWoods_tboard,
            CalculatorWoods_plank: CalculatorWoods_plank,
            CalculatorWoods_fboard: CalculatorWoods_fboard,
            CalculatorWoods_eurvagon: CalculatorWoods_eurvagon
        },
    props: {
        preproduct: {}
    },
    data () {
        return {
            config: {
                steps: 1
            },
            result: false,
            vars: {
                products: {
                        
                        tboard: {
                                'title': 'Террасная доска',
                                'img': '/local/js/tn/calculator/woods/img/tboard.png'
                            },
                        plank: {
                                'title': 'Прямой планкен',
                                'img': '/local/js/tn/calculator/woods/img/plank.png'
                            },
                        fboard: {
                                'title': 'Доска пола',
                                'img': '/local/js/tn/calculator/woods/img/fboard.png'
                            },
                        eurvagon: {
                                'title': 'Евровагонка',
                                'img': '/local/js/tn/calculator/woods/img/eurvagon.png'
                            },
                }
            },
            selectedproductcode: false,
            state: {
                view: 'wide',
                step: 1,
                calced: false,
                emailsended: false
            },
            form: {
                email: ''
            }
        }
    },
    computed: {
        product () {
            return this.selectedproductcode?this.vars.products[this.selectedproductcode]:false;
        },
        emailValid () {
            if (!this.form.email) return false;
            return Validator.isEmail(this.form.email);
        }
    },
    created () {
        
        
        this.$depot = {
                'sliders': []
            };
        
        window.addEventListener('resize', (e) => {
                this.review();
            });
        if (this.preproduct) {
            this.selectedproductcode = this.preproduct;
            this.$nextTick(this.goStep);
        }
        
        
    },
    mounted () {
        this.$nextTick(this.review);
        this.$nextTick(this.reinitSliders);
    },
    methods: {        
        goStep (n) {
            n = n || this.state.step+1
            if (n < 1 || n > this.config.steps) n = 1;
            this.state.step = n;
            window.location.hash = '';
            window.location.hash = '#step' + this.state.step;
        },
        review () {
            let width = this.$refs.main.offsetWidth;
            if (width < 10000) {
                this.state.view = 'mobile'
            } else {
                this.state.view = 'wide'
            }
        },


        $_buildHtmlResult ()
        {
            let HTML =  '<table cellpadding="0" cellspacing="0" style="width: 100%; padding: 20px 40px 50px 40px;">';
            for (let iR in this.result.rows) {
                let Row = this.result.rows[iR];
                HTML = HTML + '<tr>';
                HTML = HTML + '<td style="border-top: 1px solid #C9C9C9; padding: 10px 0;"><strong>' + Row.title + ' </strong></td><td>' + Row.value + '</td>';
                HTML = HTML + '</tr>';
            }

            HTML = HTML + '<tr>';
                HTML = HTML + '<td style="border-top: 1px solid #C9C9C9; padding: 10px 0;"><strong>Количество материала </strong></td><td>' + this.result.total + ' шт</td>';
                HTML = HTML + '</tr>';
            HTML = HTML + '</table>';

            return HTML;
        },
        
        order () {
            if (this.result?.errors?.length) {
                iziToast.error({
                        title: 'Ошибка',
                        class: 'error',
                        message: 'Расчет выполнен с ошибками'
                    });
                return;
            }
            
            if (!this.result.total) {
                iziToast.error({
                        title: 'Ошибка',
                        class: 'error',
                        message: 'Ошибка в конечном результате - перепроверьте введенные данные'
                    });
                return;
            }

            openModalForm('Заказ','ORDER',(dctFields)=>{
                    dctFields.CALCTABLE = this.$_buildHtmlResult();
                    dctFields.CALCRESULT = this.result.total;

                    return dctFields;
                },
                'Спасибо',
                'Мы получили Ваш заказ!');
            
        },
        email () {
            
            if (this.result?.errors?.length) {
                iziToast.error({
                        title: 'Ошибка',
                        class: 'error',
                        message: 'Расчет выполнен с ошибками'
                    });
                return;
            }
            
            if (!this.result.total) {
                iziToast.error({
                        title: 'Ошибка',
                        class: 'error',
                        message: 'Ошибка в конечном результате - перепроверьте введенные данные'
                    });
                return;
            }
            
            let dctFields = {
                'EMAIL': this.form.email,
                'SUBSCRIBE': this.form.subscribe?this.form.subscribe:'',
                'BODY': this.$_buildHtmlResult(),
                'RESULT': this.result.total
            }
            
            BX.ajax.runAction('x:postman.api.mail.send', {data: {
                EventName: 'CALCRESULT', 
                dctFields: dctFields,
                HlBlock: 'calclog'
            }}).then((response) => {
                if (response?.data?.result) {
                    this.state.emailsended = true;
                    iziToast.success({
                            //title: '',
                            class: 'success',
                            message: 'Данные отправлены на почту '+this.form.email
                        });
                }
            });
        },



        
        configurator (config) {
            config.steps = config.steps+2
            this.config = config;
        },
        
        resultator (result) {
            this.result = result;
        },
        
        reinitSliders () {
            
            for (let i in this.$depot.sliders) {
                let slider = this.$depot.sliders[i];
                slider.destroy(true,true);
            }
            
            let sliders = [];
            
            this.$refs.main.querySelectorAll('.js-calculator-slider').forEach((n)=>{
                let slider= new Swiper(n, {
                        slidesPerView: "auto",
                        spaceBetween: 33,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        },
                        scrollbar: {
                            el: ".swiper-scrollbar",
                            hide: true
                        },
                        breakpoints: {
                            320: {
                                spaceBetween: 14
                            },
                            1280: {
                                spaceBetween: 33
                            }
                        }
                    });
                sliders.push(slider);
            });
            
            this.$depot.sliders = sliders;
        },

        calced () {
            this.state.calced = true;
        }
        
    },
    watch: {
        'selectedproductcode': {
            handler(val, oval) {
                this.result = false;
                this.state.calced = false;
            }
        },
        'state.step': {
            handler(val, oval) {
                this.$nextTick(this.reinitSliders);
            }
        }
    },
	template: `
	<div class="tn-calculatorwoods" v-bind:class="'tn-cw-state_'+state.view" ref="main">
        <div class="calculator">
            <div class="calculator__section">
                <div class="calculator__inner contain">
                    <div class="calculator__wrapper">
    
                        
                        <div class="tn-cw-step"
                                v-if="state.view != 'wide' || state.step == 1"
                            >
                            <a name="step1"></a>
                            
                            <div class="calculator__info">
                                <div class="calculator__step">
                                    <strong v-if="state.view == 'wide'">Шаг {{state.step}}</strong>
                                    <span>Выберите продукт</span>
                                </div>
                                <div class="calculator__text">
                                    Узнайте стоимость необходимого количества материала
                                </div>
                            </div>

                            
                            <div class="calculator__container swiper js-calculator-slider">
                                <div class="calculator__items swiper-wrapper tn-cw-radimg">
                                    <div 
                                        class="calculator__item swiper-slide"
                                        v-for="(product,val) in vars.products"
                                        v-bind:id="'vars_product_'+val"
                                        v-bind:key="'vars_product_'+val"
                                        v-bind:class="{active: val == selectedproductcode}"
                                        v-on:click="selectedproductcode = val"
                                    >
                                        <div class="calculator-product-card">
                                            <div class="calculator-product-card__body">
                                                <div class="calculator-product-card__img">
                                                    <img v-bind:src="product.img" v-bind:alt="product.title">
                                                </div>
                                                <div class="calculator-product-card__content">
                                                <span></span>
                                                <div class="calculator-product-card__name">
                                                    <label v-bind:for="'vars_product_'+val">
                                                        {{product.title}}
                                                    </label>
                                                </div>
                                            </div>
                                            </div><!-- calculator-product-card -->
                                        </div>
                    
                    
                                </div>
                            </div>
                            <div class="swiper-scrollbar"></div>
                            <div class="swiper-pagination"></div>
                            </div>
                        </div> 

                        <component
                                v-if="selectedproductcode"
                                v-bind:is="'CalculatorWoods_'+selectedproductcode"
                                v-bind:step="state.step-1"
                                v-bind:stepg="state.step"
                                v-bind:view="state.view"
                                v-bind:configurator="configurator"
                                v-bind:resultator="resultator"
                                v-on:goStep="goStep"
                            ></component>

                        <div class="tn-cw-step"
                                v-if="state.view != 'wide' || (state.step > 1 && state.step == config.steps)"
                            >
                            <a v-bind:name="'step'+config.steps"></a>
                           
                            
                            <div class="tn-cw-result" v-if="state.calced">
                                <div v-if="result">

                                    <div class="result-items tn-cw-result-rows">
                                        <div class="tn-cw-result-errors" v-if="result.errors.length">
                                            <div v-for="(error,i) in result.errors" v-bind:key="'re_'+i">
                                                <p style="color: red">{{error.text}}</p>
                                                <button
                                                        v-on:click="goStep(error.step+1)" 
                                                        class="button-default"
                                                    >Шаг {{error.step+1}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="result-items tn-cw-result-rows" v-if="result.rows.length">
                                        <div class="result-item" v-for="(row,i) in result.rows" v-bind:key="'rr_'+i">
                                            <div class="result-content">
                                                <h4>{{row.title}}</h4>
                                                <p>{{row.value}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="result-info" v-if="result.total">
                                        <div class="result-text">
                                            <div class="result-title tn-cw-result-title">
                                                Необходимое Вам количество материала
                                            </div>
                                            <div class="result-total tn-cw-result-total">
                                               <span class="result-amount">
                                                    {{result.total}}
                                               </span> 
                                               <small>шт</small> 
                                               <!--<span class="result-sep">/</span>
                                               <span class="result-price">50 000 ₽</span>-->
                                            </div> 
                                        </div>

                                        <button v-if="result?.total"
                                            v-on:click="order" 
                                            class="result-button button-default"
                                        >Оформить заказ</button>
                                        
                                        <p class="result-note tn-cw-result-note">
                                            Узнать точную стоимость заказа вы сможете у менеджера, а также оформить доставку
                                        </p>

                                        <!--блок: получить результаты расчета-->


                                    </div>
                                </div>
                            </div>
                            <div class="tn-cw-result" v-else>
                                <div class="result-items tn-cw-result-rows">
                                    <button class="button-default"
                                            v-if="selectedproductcode"
                                            v-on:click="calced"
                                        >рассчитать</button>
                                </div>
                            </div>
                        </div>
                        

                        <div class="tn-cw-stepper">
                            <div class="calculator__bottom">
                                <button
                                    v-if="state.view == 'wide' && state.step > 1"
                                    v-on:click="goStep(state.step - 1)"
                                    class="calculator__button calculator__button--prev button-default"
                                ><span>Назад</span></button>
                                <div  v-if="state.view == 'wide'" class="calculator__current-step">
                                    <strong class="tn-cw-setepd">
                                        {{ state.step }}
                                    </strong>
                                    &nbsp;
                                    <span>/{{ config.steps }}</span>
                                </div>
                                <button
                                        v-if="state.view == 'wide' && state.step < config.steps"
                                        v-on:click="goStep(state.step + 1)"
                                        class="calculator__button calculator__button--next button-default"
                                    ><span>Далее</span></button>
                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!-- calculator -->
	`
}

/* получить результаты расчета
<div 
        v-if="result?.total && !state.emailsended"
        class="get-calculation-result-form"
    >
    <p>Получить результат расчёта</p>
    <div>
        <div class="input-field">
            <input type="email" v-model="form.email" placeholder="Введите свою электронную почту">
            <button class="button-default"
                    v-if="form.agreement && emailValid"
                    v-on:click="email"
                >отправить</button>
        </div>
        <div class="popup-modal__privacy-policy">
            <label class="popup-modal__label">
                <input type="checkbox" v-model="form.agreement">
                <span class="popup-modal__checkbox">
                    <i></i>
                    <span>
                        Даю <a href="#">согласие</a> на обработку моих персональных данных в соответствии <br>
                        с <a href="#">Политикой обработки персональных данных</a>
                    </span>
                </span>
            </label>
            <label class="popup-modal__label">
                <input type="checkbox" v-model="form.subscribe">
                <span class="popup-modal__checkbox">
                    <i></i>
                    <span>
                        Даю согласие ООО «ТехноНИКОЛЬ-Строительные Системы», ИНН 7702521529 (далее – Общество)
                        на получение от Общества (или от третьих лиц, действующих по поручению Общества) рекламных,
                        информационных материалов по указанному мной номеру телефона, адресу электронной почты
                    </span>
                </span>
            </label>
        </div>
    </div>
</div>
*/


window.addEventListener('load', ()=>{
    BX.ready(() => {
            loaderVue.addComponentStore(BX.TN.Vue.Components);
            loaderVue.init();
        });
});